import { createSlice } from '@reduxjs/toolkit';
import { LOGOUT } from '../../../utils/constants';
import { getUserInfoBuilder, registerBuilder } from './builder';
import { DEFAULT_START_PARAMS } from '../../../utils/telegram';

const INIT_STATE = {
  isLoggedIn: null,
  pending: {
    register: false,
    getUserInfo: false,
  },
  startParams: DEFAULT_START_PARAMS,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState: INIT_STATE,
  reducers: {
    setStartParams: (state, { payload }) => {
      state.startParams = payload;
    },
    setIsLoggedIn: (state, { payload }) => {
      state.isLoggedIn = payload;
    },
  },
  extraReducers: builder => {
    registerBuilder(builder);
    getUserInfoBuilder(builder);
    builder.addCase(LOGOUT, () => ({ ...INIT_STATE, isLoggedIn: false }));
  },
});

export const { setStartParams, setIsLoggedIn } = authSlice.actions;

export const selectIsLoggedIn = state => state.auth.isLoggedIn;
export const selectAuthActionsPending = state => state.auth.pending;
export const selectStartParams = state => state.auth.startParams;

export default authSlice.reducer;
